var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCamerai = function SvgCamerai(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 1604"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M19.519 20.002H4.479a2.33 2.33 0 0 1-2.478-2.135V8.254a2.33 2.33 0 0 1 2.478-2.135h2.568L8.278 4h7.44l1.231 2.119h2.568A2.333 2.333 0 0 1 22 8.254v9.613a2.333 2.333 0 0 1-2.481 2.135m-7.52-11.5a4.5 4.5 0 0 0-4.5 4.5 4.5 4.5 0 0 0 4.5 4.5 4.507 4.507 0 0 0 4.5-4.5A4.5 4.5 0 0 0 12 8.502z",
    "data-name": "Subtraction 19"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCamerai);
export default ForwardRef;